// removed by extract-text-webpack-plugin
module.exports = {"sidebar-overlay":"Overlay__sidebar-overlay___7iPKd","expanded":"Overlay__expanded___3K39i"};